"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTranscriptResponse = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateTranscriptResponse = (0, validation_1.properties)({
    status: (0, validation_1.text)(),
    generatedTranscript: (0, validation_1.optional)((0, validation_1.text)()),
});
//# sourceMappingURL=TranscriptResponse.js.map